exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-fdc3aa24] {\n    width: 100%;\n    height: auto;\n}\n.panel2[data-v-fdc3aa24], .panel21[data-v-fdc3aa24] {\n    background: #fcfcfc;\n    border: solid 1px #dbdbdb;\n    /*margin-bottom: 5%;*/\n    padding-bottom: 25px;\n    padding-top: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    float: left;\n    width: 100%;\n}\n*[data-v-fdc3aa24] {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n.orangeConfirmationButton[data-v-fdc3aa24] {\n  margin-top: 5%;\n}\n@media (max-width:  768px) {\n.col-md-3[data-v-fdc3aa24] {\n    margin-top: -20px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fdc3aa24","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/user/CMProfile.vue
// module id = 1179
// module chunks = 2